/**
 * Buscador de TiendaManilla.
 *
 * - Escritorio y tablet: panel predictivo bajo el buscador del header.
 * - Móvil (≤ 640 px): buscador a pantalla completa con su propio campo.
 * - Página /search: «¿Quisiste decir…?», categorías relacionadas y sugerencias sin resultados.
 *
 * Datos: /search/suggest.json (autocompletado, productos, categorías y guías), la vista
 * alternativa search.tms-count (nº real de resultados) y collection.tms (lo más vendido).
 * No se descarga NADA hasta que el cliente abre el buscador: la versión anterior bajaba
 * ~370 KB de products.json/collections.json en cada página solo para el corrector.
 *
 * Configuración y textos traducidos: #tms-config (snippet tm-search-config).
 */
(function () {
  'use strict';

  if (window.__tmSearch) return;
  window.__tmSearch = true;

  var cfgEl = document.getElementById('tms-config');
  if (!cfgEl) return;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    console.error('[buscador] configuración ilegible', e);
    return;
  }

  // Shopify escapa la salida de `t` («l'orthographe» llega como «l&#39;orthographe»): se
  // decodifica una vez aquí y cada uso vuelve a escapar con esc() o trHtml().
  function decodeEntities(s) {
    if (typeof s !== 'string' || s.indexOf('&') === -1) return s;
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  }

  var T = CFG.t || {};
  Object.keys(T).forEach(function (k) { T[k] = decodeEntities(T[k]); });
  CFG.popular = decodeEntities(CFG.popular);
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SEARCH_URL = CFG.searchUrl || ROOT + 'search';
  var PHONE = window.matchMedia('(max-width: 640px)');
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  var RECENT_KEY = 'tms_recent';
  var VIEWED_KEY = 'tms_viewed';
  var MAX_RECENT = 8;
  var MAX_VIEWED = 12;

  // ---------------------------------------------------------------------------
  // Utilidades
  // ---------------------------------------------------------------------------

  // Sin acentos ni mayúsculas: "Bombín" y "bombin" son la misma búsqueda.
  function norm(s) {
    return (s == null ? '' : String(s)).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }

  function cleanTerm(s) {
    return (s == null ? '' : String(s)).replace(/\s+/g, ' ').trim();
  }

  function esc(s) {
    return (s == null ? '' : String(s))
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Texto traducido. Los marcadores llegan como %var% (los pone tm-search-config) y se
  // sustituyen por HTML ya escapado por quien llama.
  function tr(key, vars) {
    var s = T[key] == null ? '' : String(T[key]);
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('%' + k + '%').join(vars[k]);
      });
    }
    return s;
  }

  // Como tr(), pero escapando el texto traducido: los valores (vars) ya son HTML seguro.
  function trHtml(key, vars) {
    var s = esc(T[key] == null ? '' : String(T[key]));
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('%' + k + '%').join(vars[k]);
      });
    }
    return s;
  }

  function searchHref(q) {
    return SEARCH_URL + '?q=' + encodeURIComponent(q) + '&type=product';
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    var prev = [];
    for (var j = 0; j <= b.length; j++) prev[j] = j;
    for (var i = 1; i <= a.length; i++) {
      var cur = [i];
      for (var k = 1; k <= b.length; k++) {
        cur[k] = Math.min(
          prev[k] + 1,
          cur[k - 1] + 1,
          prev[k - 1] + (a.charAt(i - 1) === b.charAt(k - 1) ? 0 : 1)
        );
      }
      prev = cur;
    }
    return prev[b.length];
  }

  // Imágenes del CDN de Shopify al tamaño que se pinta (las originales pesan 1000-3000 px).
  function sizedImage(url, width) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;
    url = url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  var store = {
    get: function (key, fallback) {
      try {
        var raw = window.localStorage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
      } catch (e) {
        return fallback;
      }
    },
    set: function (key, value) {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (e) {
        /* almacenamiento lleno o bloqueado: no pasa nada */
      }
    },
    remove: function (key) {
      try {
        window.localStorage.removeItem(key);
      } catch (e) {
        /* idem */
      }
    }
  };

  // ---------------------------------------------------------------------------
  // Precios (formato de la tienda + precio profesional sin IVA)
  // ---------------------------------------------------------------------------

  // Convierte a CÉNTIMOS. Número = ya en céntimos. Texto = euros con ',' o '.' decimal
  // ("1,67" → 167, "1.234,56" → 123456, "8.22" → 822). Evita parseFloat("1,67") = 1.
  function toCents(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'number') return Math.round(v);
    var s = String(v).trim().replace(/[^\d.,-]/g, '');
    if (s === '' || s === '-') return 0;
    var dec = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
    var euros;
    if (dec === -1) {
      euros = parseFloat(s.replace(/[.,]/g, ''));
    } else {
      var intPart = s.slice(0, dec).replace(/[.,]/g, '');
      var fracPart = s.slice(dec + 1).replace(/[.,]/g, '');
      euros = parseFloat((intPart || '0') + '.' + (fracPart || '0'));
    }
    return isNaN(euros) ? 0 : Math.round(euros * 100);
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (cents / 100).toFixed(2);

    function delimit(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = delimit(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = delimit(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = delimit(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = delimit(cents, 2, "'", '.');
        break;
      default:
        value = delimit(cents, 2, ',', '.');
    }
    return format.replace(match[0], value);
  }

  // Precio dual para profesionales: misma fórmula que pro-price.liquid,
  // neto = round(bruto_cent * 100 / (100 + IVA)).
  function priceHtml(p) {
    if (p.price == null) return '';
    var onSale = p.compare > p.price;
    var gross = formatMoney(p.price);
    var compare = onSale ? ' <s class="tms-price__compare">' + esc(formatMoney(p.compare)) + '</s>' : '';
    var from = p.varies ? '<span class="tms-price__from">' + esc(tr('from')) + '</span> ' : '';
    var pro = window.__proPricing;

    if (pro && pro.isPro) {
      var vat = Number(pro.vatRate) || 0;
      var net = formatMoney(Math.round(p.price * 100 / (100 + vat)));
      return (
        '<span class="tms-price tms-price--pro">' +
          '<span class="tms-price__main">' + from + esc(net) +
            ' <span class="tms-price__tax">' + esc(pro.labelWithout || 'sin IVA') + '</span></span>' +
          '<span class="tms-price__sub">' + esc(gross) + compare +
            ' <span class="tms-price__tax">' + esc(pro.labelWith || 'IVA incl.') + '</span></span>' +
        '</span>'
      );
    }

    return (
      '<span class="tms-price' + (onSale ? ' tms-price--sale' : '') + '">' +
        '<span class="tms-price__main">' + from + esc(gross) + '</span>' + compare +
      '</span>'
    );
  }

  // ---------------------------------------------------------------------------
  // Resaltado de coincidencias (insensible a acentos: "bombin" resalta "Bombín")
  // ---------------------------------------------------------------------------

  function queryWords(q) {
    return norm(q)
      .split(/[\s,.;:/()"'+]+/)
      .filter(function (w) { return w.length >= 2 || /^\d$/.test(w); });
  }

  function highlight(text, q) {
    text = text == null ? '' : String(text);
    var words = queryWords(q);
    if (!words.length) return esc(text);

    // Texto normalizado carácter a carácter, con el índice original de cada letra.
    var flat = '';
    var map = [];
    for (var i = 0; i < text.length; i++) {
      var n = norm(text.charAt(i));
      for (var j = 0; j < n.length; j++) {
        flat += n.charAt(j);
        map.push(i);
      }
    }

    var marks = [];
    words.forEach(function (w) {
      var from = 0;
      var at;
      while ((at = flat.indexOf(w, from)) !== -1) {
        var prev = at === 0 ? ' ' : flat.charAt(at - 1);
        if (!/[a-z0-9]/.test(prev)) marks.push([map[at], map[at + w.length - 1] + 1]);
        from = at + 1;
      }
    });
    if (!marks.length) return esc(text);

    marks.sort(function (a, b) { return a[0] - b[0]; });
    var merged = [marks[0]];
    for (var m = 1; m < marks.length; m++) {
      var last = merged[merged.length - 1];
      if (marks[m][0] <= last[1]) last[1] = Math.max(last[1], marks[m][1]);
      else merged.push(marks[m]);
    }

    var out = '';
    var cursor = 0;
    merged.forEach(function (r) {
      out += esc(text.slice(cursor, r[0])) + '<mark>' + esc(text.slice(r[0], r[1])) + '</mark>';
      cursor = r[1];
    });
    return out + esc(text.slice(cursor));
  }

  // Sugerencia al estilo Google: lo escrito normal, lo que falta en negrita.
  function completionHtml(text, q) {
    var nt = norm(text);
    var nq = norm(cleanTerm(q));
    if (nq && nt.indexOf(nq) === 0 && nt.length === text.length) {
      var rest = text.slice(nq.length);
      return esc(text.slice(0, nq.length)) + (rest ? '<b>' + esc(rest) + '</b>' : '');
    }
    return '<b>' + esc(text) + '</b>';
  }

  // ---------------------------------------------------------------------------
  // Búsquedas recientes y productos vistos (solo en este navegador)
  // ---------------------------------------------------------------------------

  (function migrateOldStorage() {
    var old = store.get('custom_recent_searches', null);
    if (Array.isArray(old) && !store.get(RECENT_KEY, null)) store.set(RECENT_KEY, old.slice(0, MAX_RECENT));
    if (old) store.remove('custom_recent_searches');
    store.remove('custom_recently_viewed_v2');
  })();

  var recent = {
    list: function () {
      var list = store.get(RECENT_KEY, []);
      return Array.isArray(list)
        ? list.filter(function (t) { return typeof t === 'string' && cleanTerm(t); }).slice(0, MAX_RECENT)
        : [];
    },
    add: function (term) {
      term = cleanTerm(term);
      if (term.length < 2 || term.length > 80) return;
      var key = norm(term);
      var list = recent.list().filter(function (t) { return norm(t) !== key; });
      list.unshift(term);
      store.set(RECENT_KEY, list.slice(0, MAX_RECENT));
    },
    remove: function (term) {
      var key = norm(term);
      store.set(RECENT_KEY, recent.list().filter(function (t) { return norm(t) !== key; }));
    },
    clear: function () {
      store.remove(RECENT_KEY);
    }
  };

  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

  // Los precios guardados solo se enseñan en la misma moneda y mercado (FR/PT/DE tienen otros precios).
  var viewed = {
    list: function () {
      var list = store.get(VIEWED_KEY, []);
      return Array.isArray(list) ? list.filter(function (p) { return p && p.u && p.t; }) : [];
    },
    track: function (p) {
      if (!p || !p.u || !p.t) return;
      var path = p.u.split('?')[0];
      var list = viewed.list().filter(function (x) { return x.u.split('?')[0] !== path; });
      list.unshift({ t: p.t, u: path, i: p.i || '', p: p.p, c: p.c, v: !!p.v, a: p.a !== false, cur: currency, host: location.host });
      store.set(VIEWED_KEY, list.slice(0, MAX_VIEWED));
    }
  };

  if (CFG.product) viewed.track(CFG.product);

  // ---------------------------------------------------------------------------
  // Datos remotos (con caché por consulta)
  // ---------------------------------------------------------------------------

  var cache = new Map();

  function cached(key, loader) {
    if (cache.has(key)) return cache.get(key);
    var promise = loader().catch(function (err) {
      cache.delete(key);
      throw err;
    });
    cache.set(key, promise);
    if (cache.size > 120) cache.delete(cache.keys().next().value);
    return promise;
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  // Las vistas alternativas del tema devuelven JSON como texto (layout none).
  function fetchView(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).then(function (text) {
      return JSON.parse(text.trim());
    });
  }

  function labelsFromTags(tags) {
    return (tags || [])
      .filter(function (t) { return /^__label[12]?:/.test(t); })
      .map(function (t) { return t.replace(/^__label[12]?:/, ''); });
  }

  function normalizeSuggestProduct(p) {
    var price = toCents(p.price);
    var min = toCents(p.price_min);
    var max = toCents(p.price_max);
    return {
      t: p.title,
      u: p.url,
      i: (p.featured_image && p.featured_image.url) || p.image || '',
      price: min || price,
      compare: toCents(p.compare_at_price_max),
      varies: max > min,
      a: p.available !== false,
      labels: labelsFromTags(p.tags)
    };
  }

  function getSuggest(q) {
    var params = new URLSearchParams();
    params.set('q', q);
    params.set('resources[type]', 'query,product,collection,article,page');
    params.set('resources[limit]', '10');
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'last');
    params.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,vendor,tag');

    return cached('s:' + norm(q), function () {
      return fetchJson(ROOT + 'search/suggest.json?' + params.toString()).then(function (data) {
        var r = (data && data.resources && data.resources.results) || {};
        return {
          queries: (r.queries || []).filter(function (x) { return x && x.text; }),
          products: (r.products || []).map(normalizeSuggestProduct),
          collections: r.collections || [],
          content: (r.pages || []).concat(r.articles || [])
        };
      });
    });
  }

  // Nº total de resultados de la búsqueda completa (la que se abre al pulsar Intro).
  function getCount(q) {
    return cached('c:' + norm(q), function () {
      return fetchView(SEARCH_URL + '?view=tms-count&type=product&q=' + encodeURIComponent(q)).then(function (data) {
        return typeof data.count === 'number' ? data.count : null;
      });
    });
  }

  function getBestSellers() {
    if (!CFG.productsUrl) return Promise.resolve([]);
    return cached('best', function () {
      return fetchView(CFG.productsUrl).then(function (data) {
        return (data.items || []).map(function (p) {
          return { t: p.t, u: p.u, i: p.i, price: p.p, compare: p.c, varies: !!p.v, a: p.a !== false, labels: p.l || [] };
        });
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Corrección «¿Quisiste decir…?»
  // ---------------------------------------------------------------------------

  // 1) Si Shopify sugiere una búsqueda casi igual a lo escrito (errata), esa.
  // 2) Si no, se corrige palabra a palabra contra las palabras de los títulos que ya
  //    han llegado: un diccionario gratis y siempre del catálogo real.
  function correctionFor(q, data) {
    var nq = norm(cleanTerm(q));
    if (nq.length < 4) return null;

    var queries = data.queries || [];
    if (queries.some(function (s) { return norm(s.text).indexOf(nq) === 0; })) return null;

    var words = nq.split(' ');
    if (queries.length) {
      var head = norm(queries[0].text).split(' ').slice(0, words.length).join(' ');
      var d = levenshtein(nq, head);
      if (d > 0 && d <= Math.max(1, Math.floor(nq.length / 4))) {
        return cleanTerm(queries[0].text.split(/\s+/).slice(0, words.length).join(' '));
      }
    }

    var vocab = [];
    var seenWord = {};
    (data.products || []).forEach(function (item) {
      norm(item.t).split(/[^a-z0-9]+/).forEach(function (w) {
        if (w.length >= 3 && !seenWord[w]) {
          seenWord[w] = true;
          vocab.push(w);
        }
      });
    });
    (data.collections || []).forEach(function (item) {
      norm(item.title).split(/[^a-z0-9]+/).forEach(function (w) {
        if (w.length >= 3 && !seenWord[w]) {
          seenWord[w] = true;
          vocab.push(w);
        }
      });
    });
    if (!vocab.length) return null;

    var changed = false;
    var fixed = words.map(function (w) {
      if (w.length < 4 || /\d/.test(w)) return w;
      if (vocab.some(function (v) { return v.indexOf(w) === 0; })) return w;

      var best = null;
      var bestDistance = w.length >= 7 ? 3 : 2;
      vocab.forEach(function (v) {
        if (Math.abs(v.length - w.length) > 2) return;
        var dist = levenshtein(w, v);
        if (dist > 0 && dist < bestDistance) {
          bestDistance = dist;
          best = v;
        }
      });
      if (best) {
        changed = true;
        return best;
      }
      return w;
    });

    return changed ? fixed.join(' ') : null;
  }

  // ---------------------------------------------------------------------------
  // Plantillas
  // ---------------------------------------------------------------------------

  var ICONS = {
    search: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/></svg>',
    clock: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>',
    trend: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m3.5 16.5 6-6 4 4 7-7"/><path d="M15 7.5h5.5V13"/></svg>',
    folder: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 7.5a2 2 0 0 1 2-2h4l2 2.5h7a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z"/></svg>',
    doc: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M14 3.5H7a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8.5z"/><path d="M14 3.5v5h5M8.5 13h7M8.5 16.5h5"/></svg>',
    fill: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M17 17 7 7M7 15V7h8"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6.5 6.5 11 11M17.5 6.5l-11 11"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4.5 12h15M13.5 6l6 6-6 6"/></svg>',
    help: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.5"/><path d="M9.6 9.4a2.5 2.5 0 1 1 3.4 2.3c-.6.3-1 .8-1 1.5v.3M12 16.8v.2"/></svg>'
  };

  var optSeq = 0;

  function optAttrs() {
    optSeq += 1;
    return ' id="tms-opt-' + optSeq + '" role="option" aria-selected="false" data-tms-opt';
  }

  function section(cls, title, inner, action) {
    if (!inner) return '';
    return (
      '<section class="tms-sec ' + cls + '" role="group" aria-label="' + esc(title) + '">' +
        '<div class="tms-sec__head"><h2 class="tms-sec__title">' + esc(title) + '</h2>' + (action || '') + '</div>' +
        inner +
      '</section>'
    );
  }

  function productRow(p, q, source) {
    var img = p.i
      ? '<img src="' + esc(sizedImage(p.i, 160)) + '" alt="" width="64" height="64" loading="lazy" decoding="async">'
      : '<span class="tms-product__noimg">' + ICONS.search + '</span>';

    var badges = '';
    if (p.compare > p.price && p.price > 0) {
      badges += '<span class="tms-badge tms-badge--sale">-' + Math.round((1 - p.price / p.compare) * 100) + '%</span>';
    }
    if (p.labels && p.labels.length) badges += '<span class="tms-badge">' + esc(p.labels[0]) + '</span>';

    var stock = p.a
      ? '<span class="tms-stock tms-stock--in">' + esc(tr('in_stock')) + '</span>'
      : '<span class="tms-stock tms-stock--out">' + esc(tr('sold_out')) + '</span>';

    return (
      '<a class="tms-product' + (p.a ? '' : ' is-soldout') + '" href="' + esc(p.u) + '"' + optAttrs() +
        ' data-tms-kind="product" data-tms-source="' + esc(source || '') + '">' +
        '<span class="tms-product__media">' + img + '</span>' +
        '<span class="tms-product__body">' +
          (badges ? '<span class="tms-product__badges">' + badges + '</span>' : '') +
          '<span class="tms-product__title">' + (q ? highlight(p.t, q) : esc(p.t)) + '</span>' +
          '<span class="tms-product__meta">' + priceHtml(p) + stock + '</span>' +
        '</span>' +
      '</a>'
    );
  }

  function productList(products, q, source) {
    if (!products.length) return '';
    return '<div class="tms-products">' + products.map(function (p) { return productRow(p, q, source); }).join('') + '</div>';
  }

  function skeletonRows(n) {
    var rows = '';
    for (var i = 0; i < n; i++) {
      rows +=
        '<div class="tms-product tms-product--skeleton" aria-hidden="true">' +
          '<span class="tms-product__media"></span>' +
          '<span class="tms-product__body"><span class="tms-skel tms-skel--l"></span><span class="tms-skel tms-skel--m"></span><span class="tms-skel tms-skel--s"></span></span>' +
        '</div>';
    }
    return '<div class="tms-products">' + rows + '</div>';
  }

  function chip(term, icon, extra) {
    return (
      '<span class="tms-chip-wrap' + (extra ? ' tms-chip-wrap--removable' : '') + '">' +
        '<a class="tms-chip" href="' + esc(searchHref(term)) + '"' + optAttrs() + ' data-tms-kind="term" data-term="' + esc(term) + '">' +
          (icon ? '<span class="tms-chip__icon">' + icon + '</span>' : '') +
          '<span class="tms-chip__text">' + esc(term) + '</span>' +
        '</a>' +
        (extra || '') +
      '</span>'
    );
  }

  function recentChips() {
    var list = recent.list();
    if (!list.length) return '';
    var chips = list.map(function (term) {
      return chip(
        term,
        ICONS.clock,
        '<button type="button" class="tms-chip__remove" tabindex="-1" data-tms-remove="' + esc(term) + '" aria-label="' + esc(tr('remove')) + ': ' + esc(term) + '">' + ICONS.close + '</button>'
      );
    }).join('');
    return section(
      'tms-sec--recent',
      tr('recent'),
      '<div class="tms-chips">' + chips + '</div>',
      '<button type="button" class="tms-sec__action" data-tms-clear-recent>' + esc(tr('clear_all')) + '</button>'
    );
  }

  function popularTerms() {
    return String(CFG.popular || '')
      .split(',')
      .map(cleanTerm)
      .filter(Boolean)
      .slice(0, 10);
  }

  function popularChips() {
    var terms = popularTerms();
    if (!terms.length) return '';
    return section(
      'tms-sec--popular',
      tr('popular'),
      '<div class="tms-chips">' + terms.map(function (t) { return chip(t, ICONS.trend); }).join('') + '</div>'
    );
  }

  // Categorías destacadas del menú: una por rama primero (manillas, herrajes,
  // seguridad, armario…) para que no salgan ocho de manillas seguidas.
  function featuredCategories(limit) {
    var cats = Array.isArray(CFG.categories) ? CFG.categories : [];
    var groups = [];
    var byGroup = {};
    cats.forEach(function (c) {
      if (!c || !c.u || !c.t) return;
      if (!byGroup[c.g]) {
        byGroup[c.g] = [];
        groups.push(c.g);
      }
      byGroup[c.g].push(c);
    });
    var out = [];
    var seen = {};
    for (var round = 0; out.length < limit && round < 12; round++) {
      groups.forEach(function (g) {
        var c = byGroup[g][round];
        if (c && out.length < limit && !seen[c.u]) {
          seen[c.u] = true;
          out.push(c);
        }
      });
    }
    return out;
  }

  function categoryChips(items, q, asList) {
    if (!items.length) return '';
    return (
      '<div class="tms-chips tms-chips--cats' + (asList ? ' tms-chips--list' : '') + '">' +
        items.map(function (c) {
          var img = c.i
            ? '<img src="' + esc(sizedImage(c.i, 96)) + '" alt="" width="28" height="28" loading="lazy" decoding="async">'
            : ICONS.folder;
          return (
            '<span class="tms-chip-wrap">' +
              '<a class="tms-chip tms-chip--cat" href="' + esc(c.u) + '"' + optAttrs() + ' data-tms-kind="category">' +
                '<span class="tms-chip__thumb">' + img + '</span>' +
                '<span class="tms-chip__text">' + (q ? highlight(c.t, q) : esc(c.t)) + '</span>' +
              '</a>' +
            '</span>'
          );
        }).join('') +
      '</div>'
    );
  }

  function suggestionList(queries, q) {
    if (!queries.length) return '';
    return (
      '<ul class="tms-list" role="presentation">' +
        queries.map(function (s) {
          return (
            '<li class="tms-list__item tms-list__item--query" role="presentation">' +
              '<a class="tms-link" href="' + esc(searchHref(s.text)) + '"' + optAttrs() + ' data-tms-kind="term" data-term="' + esc(s.text) + '">' +
                '<span class="tms-link__icon">' + ICONS.search + '</span>' +
                '<span class="tms-link__text">' + completionHtml(s.text, q) + '</span>' +
              '</a>' +
              '<button type="button" class="tms-fill" tabindex="-1" data-tms-fill="' + esc(s.text) + '" aria-label="' + esc(tr('fill')) + ': ' + esc(s.text) + '">' + ICONS.fill + '</button>' +
            '</li>'
          );
        }).join('') +
      '</ul>'
    );
  }

  function linkList(items, q, icon, kind) {
    if (!items.length) return '';
    return (
      '<ul class="tms-list" role="presentation">' +
        items.map(function (item) {
          var thumb = item.featured_image && item.featured_image.url
            ? '<span class="tms-link__thumb"><img src="' + esc(sizedImage(item.featured_image.url, 96)) + '" alt="" width="36" height="36" loading="lazy" decoding="async"></span>'
            : '<span class="tms-link__icon">' + icon + '</span>';
          return (
            '<li class="tms-list__item" role="presentation">' +
              '<a class="tms-link" href="' + esc(item.url) + '"' + optAttrs() + ' data-tms-kind="' + kind + '">' +
                thumb + '<span class="tms-link__text">' + highlight(item.title, q) + '</span>' +
              '</a>' +
            '</li>'
          );
        }).join('') +
      '</ul>'
    );
  }

  function correctionBanner(term) {
    return (
      '<div class="tms-dym">' +
        '<span class="tms-dym__icon">' + ICONS.help + '</span>' +
        '<span>' + trHtml('did_you_mean', {
          term: '<a href="' + esc(searchHref(term)) + '"' + optAttrs() + ' data-tms-kind="fix" data-term="' + esc(term) + '">' + esc(term) + '</a>'
        }) + '</span>' +
      '</div>'
    );
  }

  function viewAllButton(q, count) {
    var label;
    if (typeof count === 'number' && count > 1) label = tr('view_count', { count: count.toLocaleString(document.documentElement.lang || undefined) });
    else if (count === 1) label = tr('view_one');
    else label = tr('view_all');
    return (
      '<a class="tms-viewall" href="' + esc(searchHref(q)) + '"' + optAttrs() + ' data-tms-kind="all" data-term="' + esc(q) + '">' +
        '<span class="tms-viewall__label">' + esc(label) + '</span>' + ICONS.arrow +
      '</a>'
    );
  }

  // ---------------------------------------------------------------------------
  // Panel (escritorio) / pantalla completa (móvil)
  // ---------------------------------------------------------------------------

  var headerInput = document.querySelector('.header__search-bar-wrapper input[name="q"], .header__search-bar-wrapper .search-bar__input');
  var headerForm = headerInput ? headerInput.closest('form') : null;
  var headerBar = headerInput ? headerInput.closest('.search-bar__top') || headerInput.closest('.search-bar') : null;

  var root = document.createElement('div');
  root.className = 'tms';
  root.id = 'tms';
  root.hidden = true;
  root.innerHTML =
    '<div class="tms__backdrop" data-tms-dismiss></div>' +
    '<div class="tms__panel" role="dialog" aria-label="' + esc(tr('title')) + '">' +
      '<form class="tms__bar" action="' + esc(SEARCH_URL) + '" method="get" role="search">' +
        '<input type="hidden" name="type" value="product">' +
        '<div class="tms__field">' +
          '<span class="tms__field-icon">' + ICONS.search + '</span>' +
          '<input class="tms__input" type="search" name="q" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search"' +
            ' placeholder="' + esc(tr('placeholder_short') || tr('placeholder')) + '" aria-label="' + esc(tr('placeholder')) + '">' +
          '<button type="button" class="tms__clear" data-tms-clear aria-label="' + esc(tr('clear')) + '" hidden>' + ICONS.close + '</button>' +
        '</div>' +
        '<button type="button" class="tms__cancel" data-tms-dismiss>' + esc(tr('cancel')) + '</button>' +
      '</form>' +
      '<div class="tms__body" id="tms-list" role="listbox" aria-label="' + esc(tr('title')) + '"></div>' +
    '</div>';
  document.body.appendChild(root);

  var panel = root.querySelector('.tms__panel');
  var backdrop = root.querySelector('.tms__backdrop');
  var body = root.querySelector('.tms__body');
  var overlayInput = root.querySelector('.tms__input');
  var overlayForm = root.querySelector('.tms__bar');
  var overlayClear = root.querySelector('[data-tms-clear]');

  var state = {
    open: false,
    mode: null, // 'panel' (escritorio/tablet) | 'overlay' (móvil)
    input: null,
    q: null,
    token: 0,
    timer: 0,
    active: -1,
    opts: [],
    lastFocus: null,
    hideTimer: 0
  };

  function setupCombobox(input) {
    if (!input) return;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', 'tms-list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('enterkeyhint', 'search');
  }

  setupCombobox(headerInput);
  setupCombobox(overlayInput);

  function currentQuery() {
    return state.input ? cleanTerm(state.input.value) : '';
  }

  function refreshOpts() {
    state.opts = Array.prototype.slice.call(body.querySelectorAll('[data-tms-opt]')).filter(function (el) {
      return el.getClientRects().length > 0;
    });
    if (state.active >= state.opts.length) state.active = -1;
  }

  function openSearch(mode, presetQuery) {
    if (state.open && state.mode === mode) return;
    if (state.open) closeSearch(true);

    clearTimeout(state.hideTimer);
    state.open = true;
    state.mode = mode;
    state.input = mode === 'overlay' ? overlayInput : headerInput;
    state.lastFocus = document.activeElement;

    root.hidden = false;
    root.classList.toggle('tms--overlay', mode === 'overlay');
    root.classList.toggle('tms--panel', mode === 'panel');
    document.documentElement.classList.add('tms-open');
    if (mode === 'overlay') document.documentElement.classList.add('tms-lock');

    if (typeof presetQuery === 'string') state.input.value = presetQuery;
    state.input.setAttribute('aria-expanded', 'true');

    if (mode === 'panel') place();
    if (mode === 'overlay') {
      // El foco tiene que darse dentro del mismo toque para que iOS abra el teclado.
      overlayInput.focus({ preventScroll: true });
      var len = overlayInput.value.length;
      try { overlayInput.setSelectionRange(len, len); } catch (e) { /* type=search en algunos navegadores */ }
    }

    // Reflow para que la animación de entrada arranque desde el estado inicial.
    void root.offsetWidth;
    root.classList.add('is-visible');

    state.q = null;
    refresh(true);
  }

  function closeSearch(silent) {
    if (!state.open) return;
    clearTimeout(state.timer);
    state.token++;
    state.open = false;
    if (state.input) {
      state.input.setAttribute('aria-expanded', 'false');
      state.input.removeAttribute('aria-activedescendant');
    }
    root.classList.remove('is-visible');
    document.documentElement.classList.remove('tms-open', 'tms-lock');

    var wasOverlay = state.mode === 'overlay';
    state.mode = null;
    state.opts = [];
    state.active = -1;

    var hide = function () {
      if (state.open) return;
      root.hidden = true;
      body.innerHTML = '';
    };
    if (silent || REDUCED_MOTION.matches) hide();
    else state.hideTimer = setTimeout(hide, 200);

    if (wasOverlay) {
      overlayInput.blur();
      if (!silent && state.lastFocus && state.lastFocus.focus && document.contains(state.lastFocus) && state.lastFocus !== headerInput) {
        try { state.lastFocus.focus({ preventScroll: true }); } catch (e) { /* nada */ }
      }
    }
  }

  // Escritorio: el panel se ancla bajo el buscador del header y sigue al scroll.
  function place() {
    if (!state.open || state.mode !== 'panel' || !headerBar) return;
    var r = headerBar.getBoundingClientRect();
    if (r.bottom < 0 || r.width === 0) {
      closeSearch(true);
      return;
    }
    var vw = document.documentElement.clientWidth;
    var width = Math.min(vw - 24, Math.max(r.width, 880));
    var left = r.left;
    if (left + width > vw - 12) left = Math.max(12, vw - 12 - width);
    var top = r.bottom + 8;
    panel.style.top = top + 'px';
    panel.style.left = left + 'px';
    panel.style.width = width + 'px';
    panel.style.maxHeight = Math.max(260, window.innerHeight - top - 16) + 'px';
    backdrop.style.top = Math.max(0, r.bottom) + 'px';
  }

  var placeQueued = false;
  function queuePlace() {
    if (placeQueued || !state.open || state.mode !== 'panel') return;
    placeQueued = true;
    requestAnimationFrame(function () {
      placeQueued = false;
      place();
    });
  }

  window.addEventListener('scroll', queuePlace, { passive: true });
  window.addEventListener('resize', function () {
    if (!state.open) return;
    var want = PHONE.matches ? 'overlay' : 'panel';
    if (want !== state.mode) closeSearch(true);
    else queuePlace();
  });

  function syncClear() {
    overlayClear.hidden = !overlayInput.value;
    overlayInput.parentNode.classList.toggle('has-value', !!overlayInput.value);
  }

  // Pinta según el texto actual. `immediate` evita el retardo (al abrir, al elegir sugerencia…).
  function refresh(immediate) {
    if (!state.open) return;
    if (state.mode === 'overlay') syncClear();
    var q = currentQuery();
    if (q === state.q) return;
    state.q = q;
    clearTimeout(state.timer);
    var token = ++state.token;

    if (!q) {
      body.classList.remove('is-loading');
      renderIdle(token);
      return;
    }

    var run = function () { runQuery(q, token); };
    if (immediate || cache.has('s:' + norm(q))) run();
    else state.timer = setTimeout(run, 140);
  }

  function runQuery(q, token) {
    // Mientras llega la respuesta se dejan los resultados anteriores atenuados:
    // parpadea mucho menos que vaciar y pintar esqueletos en cada letra.
    if (!body.querySelector('[data-tms-results]')) renderSkeleton(q);
    else body.classList.add('is-loading');

    getSuggest(q).then(function (data) {
      if (token !== state.token || !state.open) return;
      body.classList.remove('is-loading');
      renderResults(q, data, token);
    }).catch(function (err) {
      if (token !== state.token || !state.open) return;
      body.classList.remove('is-loading');
      console.error('[buscador] sugerencias', err);
      renderError(q);
    });
  }

  function setBody(html) {
    optSeq = 0;
    body.innerHTML = html;
    body.scrollTop = 0;
    state.active = -1;
    refreshOpts();
    if (state.input) state.input.removeAttribute('aria-activedescendant');
  }

  function layout(aside, main, foot) {
    return (
      '<div class="tms-layout' + (aside && main ? '' : ' tms-layout--single') + '">' +
        (aside ? '<div class="tms-col tms-col--aside">' + aside + '</div>' : '') +
        (main ? '<div class="tms-col tms-col--main">' + main + '</div>' : '') +
      '</div>' +
      (foot ? '<div class="tms-foot">' + foot + '</div>' : '')
    );
  }

  function replaceSection(selector, html) {
    var target = body.querySelector(selector);
    if (!target) return;
    if (html) target.outerHTML = html;
    else target.remove();
    refreshOpts();
  }

  function renderIdle(token) {
    var aside =
      recentChips() +
      popularChips() +
      section('tms-sec--cats', tr('categories'), categoryChips(featuredCategories(8)));

    var seen = viewed.list().filter(function (p) {
      return (!p.cur || !currency || p.cur === currency) && (!p.host || p.host === location.host);
    });
    var mainProducts = seen.slice(0, 6).map(function (p) {
      return { t: p.t, u: p.u, i: p.i, price: p.p, compare: p.c, varies: p.v, a: p.a, labels: [] };
    });

    var main = section(
      'tms-sec--products',
      mainProducts.length ? tr('viewed') : tr('best_sellers'),
      mainProducts.length ? productList(mainProducts, '', 'viewed') : skeletonRows(4)
    );
    setBody('<div data-tms-idle>' + layout(aside, main) + '</div>');

    if (mainProducts.length >= 4) return;
    getBestSellers().then(function (items) {
      if (token !== state.token || !state.open) return;
      if (!mainProducts.length) {
        replaceSection('.tms-sec--products', items.length ? section('tms-sec--products', tr('best_sellers'), productList(items.slice(0, 6), '', 'best')) : '');
        return;
      }
      var urls = {};
      mainProducts.forEach(function (p) { urls[p.u.split('?')[0]] = true; });
      var extra = items.filter(function (p) { return !urls[p.u.split('?')[0]]; }).slice(0, 6 - mainProducts.length);
      if (!extra.length) return;
      var target = body.querySelector('.tms-sec--products');
      if (!target) return;
      target.insertAdjacentHTML('afterend', section('tms-sec--best', tr('best_sellers'), productList(extra, '', 'best')));
      refreshOpts();
    }).catch(function () {
      if (!mainProducts.length) replaceSection('.tms-sec--products', '');
    });
  }

  function renderSkeleton(q) {
    var aside = section('tms-sec--queries', tr('suggestions'), suggestionList([{ text: q }], q));
    var main = section('tms-sec--products', tr('products'), skeletonRows(4));
    setBody('<div data-tms-results>' + layout(aside, main) + '</div>');
  }

  function renderResults(q, data, token) {
    var products = data.products.slice(0, state.mode === 'overlay' ? 10 : 8);
    var hasAnything = products.length || data.collections.length || data.content.length || data.queries.length;

    if (!hasAnything) {
      renderNoResults(q, token);
      return;
    }

    var fix = correctionFor(q, data);

    // La primera fila es siempre lo escrito tal cual (igual que pulsar Intro).
    var queries = data.queries.slice(0, 6);
    if (!queries.some(function (s) { return norm(s.text) === norm(q); })) {
      queries = [{ text: q }].concat(queries).slice(0, 6);
    }

    var cats = data.collections.slice(0, 6).map(function (c) {
      return { t: c.title, u: c.url, i: c.featured_image && c.featured_image.url };
    });

    var aside =
      section('tms-sec--queries', tr('suggestions'), suggestionList(queries, q)) +
      section('tms-sec--cats', tr('categories'), categoryChips(cats, q, true)) +
      section('tms-sec--content', tr('content'), linkList(data.content.slice(0, 3), q, ICONS.doc, 'content'));

    var main = products.length
      ? section('tms-sec--products', tr('products'), productList(products, q, 'search'))
      : section('tms-sec--products', tr('products'), '<p class="tms-note">' + esc(tr('no_products')) + '</p>');

    setBody(
      '<div data-tms-results>' +
        (fix ? correctionBanner(fix) : '') +
        layout(aside, main, viewAllButton(q, null)) +
      '</div>'
    );

    getCount(q).then(function (count) {
      if (token !== state.token || !state.open) return;
      var label = body.querySelector('.tms-viewall__label');
      if (!label || typeof count !== 'number') return;
      var tmp = document.createElement('div');
      tmp.innerHTML = viewAllButton(q, count);
      label.textContent = tmp.querySelector('.tms-viewall__label').textContent;
    }).catch(function () { /* el texto genérico ya sirve */ });
  }

  function noResultsBlock(q) {
    return (
      '<div class="tms-noresults">' +
        '<p class="tms-noresults__title">' + trHtml('no_results_title', { terms: '<strong>' + esc(q) + '</strong>' }) + '</p>' +
        '<p class="tms-noresults__text">' + esc(tr('no_results_text')) + '</p>' +
        (CFG.contactUrl
          ? '<p class="tms-noresults__help">' + esc(tr('help_text')) + ' <a href="' + esc(CFG.contactUrl) + '"' + optAttrs() + ' data-tms-kind="contact">' + esc(tr('help_link')) + '</a></p>'
          : '') +
      '</div>'
    );
  }

  function renderNoResults(q, token) {
    var aside =
      noResultsBlock(q) +
      popularChips() +
      section('tms-sec--cats', tr('categories'), categoryChips(featuredCategories(8)));
    var main = section('tms-sec--products', tr('best_sellers'), skeletonRows(4));
    setBody('<div data-tms-results data-tms-noresults>' + layout(aside, main) + '</div>');

    getBestSellers().then(function (items) {
      if (token !== state.token || !state.open) return;
      replaceSection('.tms-sec--products', items.length ? section('tms-sec--products', tr('best_sellers'), productList(items.slice(0, 6), '', 'best')) : '');
    }).catch(function () {
      replaceSection('.tms-sec--products', '');
    });
  }

  function renderError(q) {
    var aside = section('tms-sec--queries', tr('suggestions'), suggestionList([{ text: q }], q));
    var main = '<p class="tms-note tms-note--error">' + esc(tr('error')) + '</p>';
    setBody('<div data-tms-results>' + layout(aside, main, viewAllButton(q, null)) + '</div>');
  }

  // ---------------------------------------------------------------------------
  // Teclado (combobox): flechas recorren todo, Intro abre, Esc cierra
  // ---------------------------------------------------------------------------

  function setActive(index) {
    var opts = state.opts;
    if (state.active >= 0 && opts[state.active]) {
      opts[state.active].classList.remove('is-active');
      opts[state.active].setAttribute('aria-selected', 'false');
    }
    state.active = index;
    if (index < 0 || !opts[index]) {
      state.active = -1;
      if (state.input) state.input.removeAttribute('aria-activedescendant');
      return;
    }
    var el = opts[index];
    el.classList.add('is-active');
    el.setAttribute('aria-selected', 'true');
    if (state.input) state.input.setAttribute('aria-activedescendant', el.id);
    el.scrollIntoView({ block: 'nearest' });
  }

  function onKeydown(e) {
    if (!state.open) {
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && e.target === headerInput && !PHONE.matches) {
        e.preventDefault();
        openSearch('panel');
      }
      return;
    }
    var n = state.opts.length;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (n) setActive(state.active + 1 >= n ? 0 : state.active + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (n) setActive(state.active <= 0 ? n - 1 : state.active - 1);
    } else if (e.key === 'Enter') {
      if (state.active >= 0 && state.opts[state.active]) {
        e.preventDefault();
        state.opts[state.active].click();
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      if (state.mode === 'overlay' && state.input.value) {
        state.input.value = '';
        refresh(true);
      } else {
        var input = state.input;
        closeSearch();
        if (input === headerInput) headerInput.blur();
      }
    } else if (e.key === 'Tab' && state.mode === 'panel') {
      closeSearch(true);
    }
  }

  // ---------------------------------------------------------------------------
  // Eventos
  // ---------------------------------------------------------------------------

  body.addEventListener('mousedown', function (e) {
    // En escritorio, que el campo no pierda el foco al pulsar dentro del panel.
    if (state.mode === 'panel' && !e.target.closest('input, textarea')) e.preventDefault();
  });

  body.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-tms-remove]');
    if (remove) {
      e.preventDefault();
      e.stopPropagation();
      recent.remove(remove.getAttribute('data-tms-remove'));
      state.q = null;
      refresh(true);
      return;
    }

    if (e.target.closest('[data-tms-clear-recent]')) {
      e.preventDefault();
      recent.clear();
      state.q = null;
      refresh(true);
      return;
    }

    var fill = e.target.closest('[data-tms-fill]');
    if (fill) {
      e.preventDefault();
      state.input.value = fill.getAttribute('data-tms-fill') + ' ';
      state.input.focus();
      refresh(true);
      return;
    }

    var link = e.target.closest('a[data-tms-opt]');
    if (!link) return;
    var kind = link.getAttribute('data-tms-kind');
    var typed = currentQuery();

    // «¿Quisiste decir?» corrige en el propio buscador, sin salir de la página.
    if (kind === 'fix' && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      state.input.value = link.getAttribute('data-term');
      state.input.focus();
      refresh(true);
      return;
    }

    if (kind === 'term' || kind === 'all') recent.add(link.getAttribute('data-term') || typed);
    else if (typed) recent.add(typed);

    if (kind === 'term' && state.input && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      state.input.value = link.getAttribute('data-term') || typed;
    }
  });

  // Móvil: al deslizar la lista se baja el teclado para ver más resultados.
  body.addEventListener('touchstart', function () {
    if (state.mode === 'overlay' && document.activeElement === overlayInput) overlayInput.blur();
  }, { passive: true });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-tms-dismiss]')) {
      e.preventDefault();
      closeSearch();
    }
  });

  overlayClear.addEventListener('click', function () {
    overlayInput.value = '';
    overlayInput.focus();
    refresh(true);
  });

  overlayInput.addEventListener('input', function () { refresh(false); });
  overlayInput.addEventListener('keydown', onKeydown);

  function onSubmit(e, input) {
    var q = cleanTerm(input.value);
    if (!q) {
      e.preventDefault();
      input.focus();
      return;
    }
    recent.add(q);
  }

  overlayForm.addEventListener('submit', function (e) { onSubmit(e, overlayInput); });

  if (headerInput) {
    // theme.js también escucha este campo con su buscador antiguo: pedía
    // section_id=predictive-search en cada letra aunque no se veía. Se corta aquí.
    ['input', 'focusin', 'keydown'].forEach(function (type) {
      headerInput.addEventListener(type, function (e) { e.stopPropagation(); });
    });

    headerInput.addEventListener('focus', function () {
      if (PHONE.matches) {
        var value = headerInput.value;
        headerInput.blur();
        openSearch('overlay', value);
        return;
      }
      openSearch('panel');
    });
    headerInput.addEventListener('click', function () {
      if (!state.open && !PHONE.matches) openSearch('panel');
    });
    headerInput.addEventListener('input', function () {
      if (!state.open) openSearch('panel');
      else refresh(false);
    });
    headerInput.addEventListener('keydown', onKeydown);
  }

  if (headerForm) {
    headerForm.addEventListener('submit', function (e) {
      e.stopPropagation();
      onSubmit(e, headerInput);
    });
  }

  // Cerrar al pulsar fuera (escritorio).
  document.addEventListener('pointerdown', function (e) {
    if (!state.open || state.mode !== 'panel') return;
    if (panel.contains(e.target)) return;
    if (e.target.closest && e.target.closest('.header__search-bar-wrapper')) return;
    closeSearch();
  }, true);

  document.addEventListener('focusin', function (e) {
    if (!state.open || state.mode !== 'panel') return;
    if (root.contains(e.target) || e.target === headerInput) return;
    closeSearch(true);
  });

  // La lupa del header en móvil (y cualquier [data-tms-open]) abre el buscador
  // a pantalla completa en vez de la barra desplegable del tema.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-action="toggle-search"], [data-tms-open]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var preset = trigger.getAttribute('data-tms-open') || '';
    if (PHONE.matches || !headerInput) {
      openSearch('overlay', preset);
    } else {
      if (preset) headerInput.value = preset;
      headerInput.focus();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open && e.target !== state.input) {
      closeSearch();
      return;
    }
    // «/» enfoca el buscador, salvo si se está escribiendo en otro campo.
    if (e.key === '/' && !e.ctrlKey && !e.metaKey && !e.altKey && !state.open) {
      var tag = (e.target.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable) return;
      if (!headerInput || PHONE.matches) return;
      e.preventDefault();
      headerInput.focus();
    }
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && state.open) closeSearch(true);
  });

  if (PHONE.addEventListener) {
    PHONE.addEventListener('change', function () {
      if (state.open) closeSearch(true);
    });
  }

  // ---------------------------------------------------------------------------
  // Página de resultados (/search)
  // ---------------------------------------------------------------------------

  function initResultsPage() {
    var page = document.querySelector('[data-tms-results-page]');
    if (!page) return;
    var q = cleanTerm(page.getAttribute('data-q'));
    var count = parseInt(page.getAttribute('data-count'), 10) || 0;

    // Móvil: el campo de la página abre el buscador a pantalla completa con la búsqueda puesta.
    // En móvil va en solo lectura (sin teclado propio) y el toque abre el buscador: el foco
    // del campo del buscador se da dentro del mismo clic, que es lo que iOS exige.
    var pageInput = page.querySelector('[data-tms-page-input]');
    if (pageInput) {
      var syncReadonly = function () {
        if (PHONE.matches) pageInput.setAttribute('readonly', '');
        else pageInput.removeAttribute('readonly');
      };
      syncReadonly();
      if (PHONE.addEventListener) PHONE.addEventListener('change', syncReadonly);
      pageInput.addEventListener('click', function (e) {
        if (!PHONE.matches) return;
        e.preventDefault();
        openSearch('overlay', pageInput.value);
      });
    }

    if (!q) return;
    recent.add(q);

    var refine = page.querySelector('[data-tms-refine]');
    if (!refine) return;

    getSuggest(q).then(function (data) {
      var html = '';
      var fix = correctionFor(q, data);
      if (fix && count < 24) {
        html +=
          '<p class="tms-page-dym">' + ICONS.help + '<span>' +
            trHtml('did_you_mean', { term: '<a href="' + esc(searchHref(fix)) + '">' + esc(fix) + '</a>' }) +
          '</span></p>';
      }

      var cats = data.collections.slice(0, 10);
      if (cats.length) {
        html +=
          '<div class="tms-page-row">' +
            '<p class="tms-page-row__title">' + esc(tr('related_categories')) + '</p>' +
            '<div class="tms-page-row__scroller">' +
              cats.map(function (c) {
                var img = c.featured_image && c.featured_image.url;
                return (
                  '<a class="tms-chip tms-chip--cat" href="' + esc(c.url) + '">' +
                    '<span class="tms-chip__thumb">' + (img ? '<img src="' + esc(sizedImage(img, 96)) + '" alt="" width="28" height="28" loading="lazy" decoding="async">' : ICONS.folder) + '</span>' +
                    '<span class="tms-chip__text">' + esc(c.title) + '</span>' +
                  '</a>'
                );
              }).join('') +
            '</div>' +
          '</div>';
      }

      var others = data.queries.filter(function (s) { return norm(s.text) !== norm(q); }).slice(0, 8);
      if (others.length && count < 24) {
        html +=
          '<div class="tms-page-row">' +
            '<p class="tms-page-row__title">' + esc(tr('related_searches')) + '</p>' +
            '<div class="tms-page-row__scroller">' +
              others.map(function (s) {
                return '<a class="tms-chip" href="' + esc(searchHref(s.text)) + '"><span class="tms-chip__icon">' + ICONS.search + '</span><span class="tms-chip__text">' + esc(s.text) + '</span></a>';
              }).join('') +
            '</div>' +
          '</div>';
      }

      if (html) {
        refine.innerHTML = html;
        refine.hidden = false;
      }
    }).catch(function () { /* la página funciona igual sin esto */ });
  }

  // ---------------------------------------------------------------------------
  // Filtros en /search (acabado, material, marca, precio, disponibilidad…)
  // ---------------------------------------------------------------------------
  //
  // La búsqueda de Shopify no filtra por etiquetas (Search & Discovery no tiene filtros y
  // activarlos duplicaría los filtros propios de las colecciones). Se filtra en el navegador
  // sobre los 250 resultados más relevantes, con dos vistas del tema:
  //  - search.tms-facets: etiquetas Grupo_Valor, precio, stock y valoración (JSON ligero);
  //  - search.tms-cards:  las tarjetas del propio tema (product-item), solo al filtrar.
  // Las dos se piden con la misma búsqueda y el mismo sort_by que la página: mismo orden.

  var FACET_PAGE = 250;  // máximo de Shopify por página
  var FACET_PAGES = 2;   // se filtra sobre los 500 resultados más relevantes
  var FACET_ALIASES = { 'acabado de la manilla': 'Acabado', color: 'Acabado' };
  var PRICE_EDGES = [0, 500, 1000, 2500, 5000, 10000, Infinity];
  // Solo para ordenar (no cambian lo que devuelve Shopify): raíces equivalentes en el título.
  var RANK_SYNONYMS = {
    bombin: ['cilindr'], bombines: ['cilindr'], cilindro: ['bombin'], cilindros: ['bombin'],
    bisagra: ['pernio'], bisagras: ['pernio'], pernio: ['bisag'], pernios: ['bisag'],
    pomo: ['pomit'], pomos: ['pomit']
  };
  var SWATCHES = [
    ['negro', '#1f1f21'], ['blanco', '#ffffff'], ['grafito', '#4a4b50'], ['antracita', '#3b3d40'], ['gris', '#8d8f93'],
    ['niquel', 'linear-gradient(135deg,#ececec,#b4b6b9)'], ['inox', 'linear-gradient(135deg,#f4f4f4,#a3a7ac)'],
    ['acero', 'linear-gradient(135deg,#f4f4f4,#a3a7ac)'], ['cromo', 'linear-gradient(135deg,#ffffff,#9aa0a6)'],
    ['plat', 'linear-gradient(135deg,#f7f7f7,#b9bcc0)'], ['titanio', '#8a8984'], ['champan', '#d9c49c'], ['champagne', '#d9c49c'],
    ['dorado', 'linear-gradient(135deg,#f6e27f,#b88d2a)'], ['oro', 'linear-gradient(135deg,#f6e27f,#b88d2a)'],
    ['laton', 'linear-gradient(135deg,#efd585,#a98128)'], ['bronce', '#8a6038'], ['cobre', '#b8733b'], ['cuero', '#9b6b43'],
    ['forja', '#353535'], ['marron', '#6b4426'], ['madera', '#a0703f'], ['rojo', '#b3262b'], ['verde', '#3f7a4a'], ['azul', '#2e5c9a']
  ];

  function swatchFor(value) {
    var v = norm(value);
    for (var i = 0; i < SWATCHES.length; i++) {
      if (v.indexOf(SWATCHES[i][0]) !== -1) return SWATCHES[i][1];
    }
    return null;
  }

  function moneyShort(cents) {
    return formatMoney(cents).replace(/[.,]00(?!\d)/, '');
  }

  function priceBucketLabel(i) {
    var min = PRICE_EDGES[i];
    var max = PRICE_EDGES[i + 1];
    if (min === 0) return trHtml('price_under', { max: esc(moneyShort(max)) });
    if (max === Infinity) return trHtml('price_over', { min: esc(moneyShort(min)) });
    return trHtml('price_between', { min: esc(moneyShort(min)), max: esc(moneyShort(max)) });
  }

  function priceBucket(cents) {
    for (var i = 0; i < PRICE_EDGES.length - 1; i++) {
      if (cents >= PRICE_EDGES[i] && cents < PRICE_EDGES[i + 1]) return i;
    }
    return PRICE_EDGES.length - 2;
  }

  // Valores tipo "52mm", "230 mm", "1,5": orden numérico; el resto por nº de productos.
  function numericValue(v) {
    var m = String(v).replace(',', '.').match(/^\s*(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }

  function initFacets(page, q, count) {
    var card = page.querySelector('.collection .card');
    var header = card && card.querySelector('.card__header');
    if (!card || !header || count < 4) return;

    var sectionId = page.getAttribute('data-section-id');
    var settings = {};
    try { settings = JSON.parse(page.getAttribute('data-section-settings') || '{}'); } catch (e) { /* por defecto */ }

    var F = {
      data: null,       // { sort, count, items }
      groups: [],       // [{ key, label, values: [{ v, n }] }]
      sel: {},          // key → { valor: true }
      price: {},        // índice de tramo → true
      avail: false,
      rating: false,
      shown: 24,
      expanded: false,  // «Ver más» sin filtros: la lista pasa a ser la ordenada por el buscador
      serverCount: 24,  // tarjetas que pintó el servidor en esta página
      rules: {},
      labels: {},       // grupo → nombre visible
      display: {},      // grupo → valor normalizado → nombre visible
      swatchOf: {},     // 'grupo|valor' → color del configurador
      cards: {},        // 'orden|página' → promesa de Map(path → tarjeta)
      server: null,     // tarjetas originales del servidor, para volver a ellas
      serverList: null
    };

    var bar = document.createElement('div');
    bar.className = 'tms-filters';
    bar.hidden = true;
    header.insertAdjacentElement('afterend', bar);

    var drawer = document.createElement('div');
    drawer.className = 'tms-drawer';
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="tms-drawer__backdrop" data-tms-fclose></div>' +
      '<aside class="tms-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="tms-drawer-title">' +
        '<header class="tms-drawer__head">' +
          '<h2 class="tms-drawer__title" id="tms-drawer-title">' + esc(tr('filters')) + '</h2>' +
          '<button type="button" class="tms-drawer__close" data-tms-fclose aria-label="' + esc(tr('close')) + '">' + ICONS.close + '</button>' +
        '</header>' +
        '<div class="tms-drawer__body"></div>' +
        '<footer class="tms-drawer__foot">' +
          '<button type="button" class="tms-drawer__clear" data-tms-fclear>' + esc(tr('clear_filters')) + '</button>' +
          '<button type="button" class="tms-drawer__apply button button--primary" data-tms-fclose></button>' +
        '</footer>' +
      '</aside>';
    document.body.appendChild(drawer);
    var drawerBody = drawer.querySelector('.tms-drawer__body');
    var drawerApply = drawer.querySelector('.tms-drawer__apply');

    function currentSort() {
      return new URL(window.location.href).searchParams.get('sort_by') || '';
    }

    function viewUrl(view, pageNumber) {
      var sort = currentSort();
      return SEARCH_URL + '?view=' + view + '&type=product&q=' + encodeURIComponent(q) +
        (sort ? '&sort_by=' + encodeURIComponent(sort) : '') +
        (pageNumber > 1 ? '&page=' + pageNumber : '');
    }

    // ---- datos ---------------------------------------------------------------

    // Reglas del configurador de filtros (las mismas de las colecciones): fusiones,
    // valores ocultos y colores, por prefijo de etiqueta.
    function buildRules(list) {
      var rules = {};
      (list || []).forEach(function (x) {
        if (!x || !x.p) return;
        var r = rules[norm(x.p)] || (rules[norm(x.p)] = { merge: {}, hidden: {}, swatch: {} });
        (x.h || []).forEach(function (v) { r.hidden[norm(v)] = true; });
        (x.m || []).forEach(function (m) {
          (m.from || []).forEach(function (from) { if (m.into) r.merge[norm(from)] = m.into; });
        });
        Object.keys(x.s || {}).forEach(function (v) { if (x.s[v]) r.swatch[norm(v)] = x.s[v]; });
      });
      return rules;
    }

    // Entre variantes de un mismo valor («Niquel Satinado», «Níquel satinado») se enseña la
    // más usada; a igualdad, la que lleva acentos.
    function betterDisplay(a, b, counts) {
      if (!a) return b;
      if ((counts[b] || 0) !== (counts[a] || 0)) return (counts[b] || 0) > (counts[a] || 0) ? b : a;
      return norm(b) !== b.toLowerCase() && norm(a) === a.toLowerCase() ? b : a;
    }

    function loadData() {
      var sort = currentSort();
      var pages = Math.max(1, Math.min(FACET_PAGES, Math.ceil(count / FACET_PAGE)));
      var requests = [];
      for (var pn = 1; pn <= pages; pn++) requests.push(fetchView(viewUrl('tms-facets', pn)));
      return Promise.all(requests).then(function (responses) {
        var raw = { count: responses[0].count, dict: responses[0].dict, items: [] };
        responses.forEach(function (r, i) {
          (r.items || []).forEach(function (it) {
            it.pg = i + 1;
            raw.items.push(it);
          });
        });
        var rules = buildRules(raw.dict);
        var variants = {}; // grupo → valor normalizado → { variante: nº }
        F.rules = rules;
        F.labels = {};
        var items = (raw.items || []).map(function (it) {
          var facets = {};
          (it.g || []).forEach(function (tag) {
            var cut = tag.indexOf('_');
            if (cut <= 0) return;
            var group = cleanTerm(tag.slice(0, cut));
            var value = cleanTerm(tag.slice(cut + 1));
            if (!group || !value) return;
            var rule = rules[norm(group)];
            if (rule) {
              if (rule.hidden[norm(value)]) return;
              if (rule.merge[norm(value)]) value = rule.merge[norm(value)];
            }
            var label = FACET_ALIASES[norm(group)] || group;
            var key = norm(label);
            var vk = norm(value);
            if (!F.labels[key]) F.labels[key] = label;
            if (!facets[key]) facets[key] = { values: {} };
            facets[key].values[vk] = true;
            var vv = (variants[key] || (variants[key] = {}))[vk] || (variants[key][vk] = {});
            vv[value] = (vv[value] || 0) + 1;
            if (!F.swatchOf[key + '|' + vk] && rule && rule.swatch[vk]) F.swatchOf[key + '|' + vk] = rule.swatch[vk];
          });
          return { path: it.u, pg: it.pg, title: norm(it.t), price: Number(it.p) || 0, a: it.a !== false, r: parseFloat(it.r) || 0, facets: facets };
        });

        // ¿Lleva lo buscado en el TÍTULO? (raíz de cada palabra, para tolerar género y plural:
        // «negra» ↔ «negro», «bisagras»; y sinónimos de oficio como bombín ↔ cilindro).
        var stems = queryWords(q)
          .filter(function (w) { return w.length >= 3 || /\d/.test(w); })
          .map(function (w) {
            var base = /\d/.test(w) ? w : w.slice(0, Math.max(4, w.length - 2));
            return [base].concat(RANK_SYNONYMS[w] || []);
          });
        items.forEach(function (it, i) {
          var title = ' ' + it.title.replace(/[^a-z0-9]+/g, ' ');
          it.idx = i;
          it.match = !stems.length || stems.every(function (alts) {
            return alts.some(function (stem) { return title.indexOf(' ' + stem) !== -1; });
          });
        });
        F.display = {};
        Object.keys(variants).forEach(function (key) {
          F.display[key] = {};
          Object.keys(variants[key]).forEach(function (vk) {
            var best = null;
            Object.keys(variants[key][vk]).forEach(function (variant) { best = betterDisplay(best, variant, variants[key][vk]); });
            F.display[key][vk] = best;
          });
        });
        F.data = { sort: sort, count: raw.count || items.length, items: items };
        buildGroups();
      });
    }

    function displayOf(key, vk) {
      return (F.display[key] && F.display[key][vk]) || vk;
    }

    function buildGroups() {
      var items = F.data.items;
      var stats = {};
      items.forEach(function (it) {
        Object.keys(it.facets).forEach(function (key) {
          var f = it.facets[key];
          if (!stats[key]) stats[key] = { key: key, label: F.labels[key] || key, cover: 0, values: {} };
          stats[key].cover += 1;
          Object.keys(f.values).forEach(function (v) {
            stats[key].values[v] = (stats[key].values[v] || 0) + 1;
          });
        });
      });

      var minCover = Math.max(3, Math.ceil(items.length * 0.12));
      F.groups = Object.keys(stats)
        .map(function (k) { return stats[k]; })
        .filter(function (g) { return g.cover >= minCover && Object.keys(g.values).length >= 2; })
        .sort(function (a, b) { return b.cover - a.cover; })
        .slice(0, 10)
        .map(function (g) {
          var values = Object.keys(g.values).map(function (v) { return { v: v, label: displayOf(g.key, v), n: g.values[v] }; });
          var numeric = values.every(function (x) { return numericValue(x.label) !== null; });
          values.sort(numeric
            ? function (a, b) { return numericValue(a.label) - numericValue(b.label); }
            : function (a, b) { return b.n - a.n || a.label.localeCompare(b.label); });
          return { key: g.key, label: g.label, values: values, swatch: g.key === 'acabado' };
        });
    }

    // ---- estado ----------------------------------------------------------------

    function activeCount() {
      var n = 0;
      Object.keys(F.sel).forEach(function (k) { n += Object.keys(F.sel[k]).length; });
      return n + Object.keys(F.price).length + (F.avail ? 1 : 0) + (F.rating ? 1 : 0);
    }

    // Devuelve los grupos que NO cumple el producto ('price', 'avail', 'rating' o la clave).
    function failures(it) {
      var fails = [];
      Object.keys(F.sel).forEach(function (key) {
        var wanted = Object.keys(F.sel[key]);
        if (!wanted.length) return;
        var has = it.facets[key] && wanted.some(function (v) { return it.facets[key].values[v]; });
        if (!has) fails.push(key);
      });
      if (Object.keys(F.price).length && !F.price[priceBucket(it.price)]) fails.push('price');
      if (F.avail && !it.a) fails.push('avail');
      if (F.rating && it.r < 4) fails.push('rating');
      return fails;
    }

    // Recuentos «disyuntivos»: cada grupo cuenta como si él mismo no estuviera filtrado.
    function counts() {
      var c = { groups: {}, price: {}, avail: 0, availBase: 0, rating: 0, total: 0 };
      F.data.items.forEach(function (it) {
        var fails = failures(it);
        if (!fails.length) c.total += 1;
        var passesExcept = function (key) { return !fails.length || (fails.length === 1 && fails[0] === key); };

        F.groups.forEach(function (g) {
          if (!passesExcept(g.key) || !it.facets[g.key]) return;
          var bucket = c.groups[g.key] || (c.groups[g.key] = {});
          Object.keys(it.facets[g.key].values).forEach(function (v) { bucket[v] = (bucket[v] || 0) + 1; });
        });
        if (passesExcept('price')) {
          var b = priceBucket(it.price);
          c.price[b] = (c.price[b] || 0) + 1;
        }
        if (passesExcept('avail')) {
          c.availBase += 1;
          if (it.a) c.avail += 1;
        }
        if (passesExcept('rating') && it.r >= 4) c.rating += 1;
      });
      return c;
    }

    function stateToUrl() {
      var url = new URL(window.location.href);
      if (!activeCount()) {
        url.searchParams.delete('tf');
      } else {
        // Formato compartible: grupo:valor,valor|_p:1,2|_a|_r. Solo se codifican los
        // separadores dentro de cada trozo (un valor como «1,5 mm» se perdía).
        var part = function (x) {
          return String(x).replace(/%/g, '%25').replace(/:/g, '%3A').replace(/\|/g, '%7C').replace(/,/g, '%2C');
        };
        var parts = [];
        Object.keys(F.sel).forEach(function (k) {
          var v = Object.keys(F.sel[k]);
          if (v.length) parts.push(part(k) + ':' + v.map(part).join(','));
        });
        if (Object.keys(F.price).length) parts.push('_p:' + Object.keys(F.price).join(','));
        if (F.avail) parts.push('_a');
        if (F.rating) parts.push('_r');
        url.searchParams.set('tf', parts.join('|'));
      }
      if (url.toString() !== window.location.href) {
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    function stateFromUrl() {
      var raw = new URL(window.location.href).searchParams.get('tf');
      if (!raw) return;
      var decode = function (x) {
        try { return decodeURIComponent(x); } catch (e) { return x; }
      };
      raw.split('|').forEach(function (part) {
        var cut = part.indexOf(':');
        var key = norm(decode(cut === -1 ? part : part.slice(0, cut)));
        var values = cut === -1 ? [] : part.slice(cut + 1).split(',').filter(Boolean).map(decode);
        if (key === '_a') F.avail = true;
        else if (key === '_r') F.rating = true;
        else if (key === '_p') values.forEach(function (i) { if (/^\d+$/.test(i) && Number(i) < PRICE_EDGES.length - 1) F.price[i] = true; });
        else if (key && values.length) {
          F.sel[key] = F.sel[key] || {};
          values.forEach(function (v) { F.sel[key][norm(v)] = true; });
        }
      });
    }

    // ---- barra -------------------------------------------------------------------

    var FILTER_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 6.5h16M7 12h10M10 17.5h4"/></svg>';
    var CHEVRON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m7 10 5 5 5-5"/></svg>';

    function renderBar(c) {
      // Se recuerda qué botón tenía el foco para devolvérselo tras repintar.
      var focused = bar.contains(document.activeElement) ? document.activeElement : null;
      var focusOpen = focused ? focused.getAttribute('data-tms-fopen') : null;
      var focusToggle = focused ? focused.getAttribute('data-tms-ftoggle') : null;
      var n = activeCount();
      var pills =
        '<button type="button" class="tms-fpill tms-fpill--main' + (n ? ' is-on' : '') + '" data-tms-fopen="">' +
          FILTER_ICON + '<span>' + esc(tr('filters')) + '</span>' + (n ? '<span class="tms-fpill__count">' + n + '</span>' : '') +
        '</button>';

      F.groups.slice(0, 6).forEach(function (g) {
        var on = F.sel[g.key] && Object.keys(F.sel[g.key]).length;
        pills += '<button type="button" class="tms-fpill' + (on ? ' is-on' : '') + '" data-tms-fopen="' + esc(g.key) + '"><span>' + esc(g.label) + '</span>' + CHEVRON + '</button>';
      });
      pills += '<button type="button" class="tms-fpill' + (Object.keys(F.price).length ? ' is-on' : '') + '" data-tms-fopen="price"><span>' + esc(tr('price')) + '</span>' + CHEVRON + '</button>';
      if (F.avail || c.avail < c.availBase) {
        pills += '<button type="button" class="tms-fpill tms-fpill--toggle' + (F.avail ? ' is-on' : '') + '" data-tms-ftoggle="avail" aria-pressed="' + F.avail + '"><span>' + esc(tr('only_available')) + '</span></button>';
      }

      var chips = '';
      Object.keys(F.sel).forEach(function (k) {
        Object.keys(F.sel[k]).forEach(function (v) {
          chips += '<button type="button" class="tms-fchip" data-tms-fremove="' + esc(k) + '" data-v="' + esc(v) + '"><span>' + esc(displayOf(k, v)) + '</span>' + ICONS.close + '</button>';
        });
      });
      Object.keys(F.price).forEach(function (i) {
        chips += '<button type="button" class="tms-fchip" data-tms-fremove="price" data-v="' + i + '"><span>' + priceBucketLabel(Number(i)) + '</span>' + ICONS.close + '</button>';
      });
      if (F.rating) chips += '<button type="button" class="tms-fchip" data-tms-fremove="rating"><span>' + esc(tr('rating_4')) + '</span>' + ICONS.close + '</button>';

      var note = F.data.count > F.data.items.length
        ? '<p class="tms-filters__note">' + esc(tr('filter_note', { count: String(F.data.items.length) })) + '</p>'
        : '';

      bar.innerHTML =
        '<div class="tms-filters__bar">' + pills + '</div>' +
        (chips
          ? '<div class="tms-filters__active">' + chips + '<button type="button" class="tms-filters__clear" data-tms-fclear>' + esc(tr('clear_filters')) + '</button></div>'
          : '') +
        (n ? note : '');
      bar.hidden = false;

      if (focused) {
        var again = Array.prototype.filter.call(bar.querySelectorAll('button'), function (b) {
          if (focusOpen !== null) return b.getAttribute('data-tms-fopen') === focusOpen;
          if (focusToggle) return b.getAttribute('data-tms-ftoggle') === focusToggle;
          return false;
        })[0] || bar.querySelector('.tms-fpill--main');
        if (again) again.focus({ preventScroll: true });
      }
    }

    // ---- cajón (escritorio) / hoja inferior (móvil) -----------------------------

    function optionRow(kind, key, value, label, n, checked, swatch) {
      var disabled = !n && !checked;
      return (
        '<label class="tms-fopt' + (disabled ? ' is-disabled' : '') + '">' +
          '<input type="checkbox" data-kind="' + kind + '" data-key="' + esc(key) + '" data-v="' + esc(value) + '"' + (checked ? ' checked' : '') + (disabled ? ' disabled' : '') + '>' +
          '<span class="tms-fopt__box" aria-hidden="true"></span>' +
          (swatch ? '<span class="tms-fopt__swatch" style="background:' + esc(swatch) + '"></span>' : '') +
          '<span class="tms-fopt__label">' + label + '</span>' +
          '<span class="tms-fopt__n">' + n + '</span>' +
        '</label>'
      );
    }

    function groupBlock(id, title, summary, inner, open) {
      return (
        '<details class="tms-fgroup" data-group="' + esc(id) + '"' + (open ? ' open' : '') + '>' +
          '<summary class="tms-fgroup__head"><span class="tms-fgroup__title">' + esc(title) + '</span>' +
            (summary ? '<span class="tms-fgroup__sum">' + esc(summary) + '</span>' : '') + CHEVRON + '</summary>' +
          '<div class="tms-fgroup__body">' + inner + '</div>' +
        '</details>'
      );
    }

    function renderDrawer(c, focusKey) {
      var openGroups = {};
      drawerBody.querySelectorAll('details[open]').forEach(function (d) { openGroups[d.getAttribute('data-group')] = true; });
      var first = !drawerBody.innerHTML;
      var html = '';

      F.groups.forEach(function (g, gi) {
        var sel = F.sel[g.key] || {};
        var gc = c.groups[g.key] || {};
        var rows = g.values.map(function (x, i) {
          var color = g.swatch ? (F.swatchOf[g.key + '|' + x.v] || swatchFor(x.label)) : null;
          var row = optionRow('g', g.key, x.v, esc(x.label), gc[x.v] || 0, !!sel[x.v], color);
          return i >= 8 ? row.replace('class="tms-fopt', 'class="tms-fopt tms-fopt--more') : row;
        }).join('');
        var more = g.values.length > 8
          ? '<button type="button" class="tms-fgroup__more" data-tms-fmore>' + esc(tr('see_more')) + ' (' + (g.values.length - 8) + ')</button>'
          : '';
        var chosen = Object.keys(sel).map(function (v) { return displayOf(g.key, v); });
        var open = focusKey ? focusKey === g.key : (first ? gi < 2 || chosen.length > 0 : !!openGroups[g.key]);
        html += groupBlock(g.key, g.label, chosen.join(', '), '<div class="tms-fopts' + (g.swatch ? ' tms-fopts--swatch' : '') + '">' + rows + '</div>' + more, open);
      });

      var priceRows = '';
      for (var i = 0; i < PRICE_EDGES.length - 1; i++) {
        if (c.price[i] || F.price[i]) priceRows += optionRow('p', 'price', String(i), priceBucketLabel(i), c.price[i] || 0, !!F.price[i]);
      }
      var priceOpen = focusKey ? focusKey === 'price' : (first ? Object.keys(F.price).length > 0 : !!openGroups.price);
      html += groupBlock('price', tr('price'), Object.keys(F.price).length ? String(Object.keys(F.price).length) : '', '<div class="tms-fopts">' + priceRows + '</div>', priceOpen);

      var other =
        optionRow('a', 'avail', '1', esc(tr('only_available')), c.avail, F.avail) +
        (c.rating || F.rating ? optionRow('r', 'rating', '1', esc(tr('rating_4')), c.rating, F.rating) : '');
      html += groupBlock('other', tr('availability'), '', '<div class="tms-fopts">' + other + '</div>', true);

      if (F.data.count > F.data.items.length) {
        html += '<p class="tms-drawer__note">' + esc(tr('filter_note', { count: String(F.data.items.length) })) + '</p>';
      }

      // Se repinta con los recuentos nuevos sin perder el scroll ni la casilla enfocada.
      var focused = drawerBody.contains(document.activeElement) && document.activeElement.matches('input')
        ? [document.activeElement.getAttribute('data-kind'), document.activeElement.getAttribute('data-key'), document.activeElement.getAttribute('data-v')]
        : null;
      var expanded = {};
      drawerBody.querySelectorAll('.tms-fgroup__body.is-expanded').forEach(function (b) {
        expanded[b.parentNode.getAttribute('data-group')] = true;
      });
      var scroll = drawerBody.scrollTop;
      drawerBody.innerHTML = html;
      drawerBody.scrollTop = scroll;
      Object.keys(expanded).forEach(function (key) {
        var group = Array.prototype.filter.call(drawerBody.querySelectorAll('.tms-fgroup'), function (d) { return d.getAttribute('data-group') === key; })[0];
        if (!group) return;
        group.querySelector('.tms-fgroup__body').classList.add('is-expanded');
        var btn = group.querySelector('[data-tms-fmore]');
        if (btn) btn.remove();
      });
      if (focused) {
        var again = Array.prototype.filter.call(drawerBody.querySelectorAll('input'), function (i) {
          return i.getAttribute('data-kind') === focused[0] && i.getAttribute('data-key') === focused[1] && i.getAttribute('data-v') === focused[2];
        })[0];
        if (again) again.focus({ preventScroll: true });
      }

      drawerApply.textContent = c.total === 1 ? tr('show_one') : c.total === 0 ? tr('show_none') : tr('show_results', { count: String(c.total) });
      drawerApply.disabled = c.total === 0;
      drawer.querySelector('[data-tms-fclear]').hidden = !activeCount();
    }

    var lastFocus = null;
    var openedWith = null;
    var drawerChanged = false;

    function openDrawer(focusKey) {
      lastFocus = document.activeElement;
      openedWith = focusKey || '';
      drawerChanged = false;
      renderDrawer(counts(), focusKey || null);
      drawer.hidden = false;
      document.documentElement.classList.add('tms-lock', 'tms-drawer-open');
      void drawer.offsetWidth;
      drawer.classList.add('is-visible');
      if (focusKey) {
        var target = Array.prototype.filter.call(drawerBody.querySelectorAll('.tms-fgroup'), function (d) {
          return d.getAttribute('data-group') === focusKey;
        })[0];
        if (target) target.scrollIntoView({ block: 'start' });
      }
      var closeBtn = drawer.querySelector('.tms-drawer__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function closeDrawer() {
      if (drawer.hidden) return;
      drawer.classList.remove('is-visible');
      document.documentElement.classList.remove('tms-lock', 'tms-drawer-open');
      setTimeout(function () { if (!drawer.classList.contains('is-visible')) drawer.hidden = true; }, REDUCED_MOTION.matches ? 0 : 220);
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* nada */ }
      } else {
        var pill = Array.prototype.filter.call(bar.querySelectorAll('[data-tms-fopen]'), function (b) {
          return b.getAttribute('data-tms-fopen') === openedWith;
        })[0] || bar.querySelector('.tms-fpill--main');
        if (pill) pill.focus({ preventScroll: true });
      }
      if (drawerChanged) scrollToGrid();
    }

    // ---- tarjetas ------------------------------------------------------------------

    function productList() {
      return page.querySelector('.collection__dynamic-part .product-list--collection');
    }

    function getCards(pageNumber) {
      var key = currentSort() + '|' + pageNumber;
      if (F.cards[key]) return F.cards[key];
      F.cards[key] = fetch(viewUrl('tms-cards', pageNumber), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var map = new Map();
          tmp.querySelectorAll('.product-item').forEach(function (el) {
            var link = el.querySelector('a[href*="/products/"]');
            if (!link) return;
            var path = new URL(link.getAttribute('href'), window.location.origin).pathname;
            if (!map.has(path)) map.set(path, el);
          });
          return map;
        })
        .catch(function (err) {
          delete F.cards[key];
          throw err;
        });
      return F.cards[key];
    }

    // Tarjetas de los productos indicados: solo se piden las páginas que hacen falta.
    function cardsFor(items) {
      var pages = {};
      items.forEach(function (it) { pages[it.pg || 1] = true; });
      var list = Object.keys(pages).map(Number);
      return Promise.all(list.map(getCards)).then(function (maps) {
        var all = new Map();
        maps.forEach(function (m) { m.forEach(function (el, path) { if (!all.has(path)) all.set(path, el); }); });
        return all;
      });
    }

    // Las tarjetas vienen en modo cuadrícula; se adaptan a la vista elegida (cuadrícula/lista)
    // y la vista rápida apunta al modal de esta sección.
    function adaptCard(el) {
      var list = page.querySelector('.collection__layout-button.is-selected[data-layout-mode="list"]');
      el.className = list ? 'product-item product-item--list' : 'product-item product-item--vertical ' + (settings.gridClasses || '');
      el.querySelectorAll('[aria-controls^="modal-quick-view-"]').forEach(function (b) {
        b.setAttribute('aria-controls', 'modal-quick-view-' + sectionId);
      });
      return el;
    }

    var countEls = [];
    function rememberCounts() {
      countEls = Array.prototype.slice.call(page.querySelectorAll('.collection__products-count-total, .collection__showing-count'));
      countEls.forEach(function (el) {
        if (!el.hasAttribute('data-tms-orig')) el.setAttribute('data-tms-orig', el.innerHTML);
      });
    }

    function setCounts(text) {
      rememberCounts();
      countEls.forEach(function (el) {
        el.innerHTML = text == null ? el.getAttribute('data-tms-orig') : esc(text);
      });
    }

    function togglePagination(show) {
      page.querySelectorAll('.collection__dynamic-part .pagination').forEach(function (p) { p.style.display = show ? '' : 'none'; });
    }

    function restoreServer() {
      var list = productList();
      if (list && F.server && F.serverList === list) {
        // Si entretanto se cambió entre lista y cuadrícula, el tema solo re-clasificó las
        // tarjetas que estaban en pantalla (las filtradas).
        F.server.forEach(function (el) { if (el.classList && el.classList.contains('product-item')) adaptCard(el); });
        list.replaceChildren.apply(list, F.server);
      }
      F.server = null;
      F.serverList = null;
      var extra = page.querySelector('.tms-loadmore');
      if (extra) extra.remove();
      var empty = page.querySelector('.tms-fempty');
      if (empty) empty.remove();
      togglePagination(true);
      setCounts(null);
      if (list) list.classList.remove('is-filtering');
    }

    var applyToken = 0;

    function applyGrid(resetShown) {
      // Cualquier llamada invalida las tarjetas que estén llegando de una anterior (si no,
      // quitar un filtro antes de que llegaran volvía a pintar las filtradas).
      var token = ++applyToken;
      if (resetShown) F.shown = 24;
      if (!listMode()) {
        restoreServer();
        offerMore();
        return;
      }
      var list = productList();
      if (!list) return;
      if (F.serverList !== list) {
        F.server = Array.prototype.slice.call(list.children);
        F.serverList = list;
      }

      var filtering = activeCount() > 0;
      list.classList.add('is-filtering');
      var matched = ordered().filter(function (it) { return !failures(it).length; });
      var total = filtering ? matched.length : F.data.count;
      setCounts(filtering
        ? tr('filtered_count', { count: String(matched.length), total: String(F.data.count) })
        : tr('showing', { count: String(Math.min(F.shown, matched.length)), total: String(total) }));

      var shown = matched.slice(0, F.shown);
      (shown.length ? cardsFor(shown) : Promise.resolve(new Map())).then(function (cards) {
        if (token !== applyToken) return;
        list.classList.remove('is-filtering');
        var nodes = [];
        shown.forEach(function (it) {
          var card = cards.get(it.path);
          if (card) nodes.push(adaptCard(card.cloneNode(true)));
        });
        list.replaceChildren.apply(list, nodes);
        togglePagination(false);

        var empty = page.querySelector('.tms-fempty');
        if (!matched.length) {
          if (!empty) {
            list.insertAdjacentHTML('afterend',
              '<div class="tms-fempty"><p>' + esc(tr('no_filtered')) + '</p><button type="button" class="button button--secondary" data-tms-fclear>' + esc(tr('clear_filters')) + '</button></div>');
          }
        } else if (empty) {
          empty.remove();
        }

        if (matched.length > F.shown) {
          setLoadMore(list, loadMoreHtml(Math.min(F.shown, matched.length), total));
        } else if (!filtering && F.data.count > F.data.items.length) {
          // Más allá de los 500 más relevantes no se puede seguir: se invita a concretar.
          setLoadMore(list, '<p class="tms-loadmore__count">' + esc(tr('more_note', { count: String(F.data.items.length) })) + '</p>');
        } else {
          setLoadMore(list, '');
        }
      }).catch(function (err) {
        console.error('[buscador] tarjetas filtradas', err);
        list.classList.remove('is-filtering');
      });
    }

    function isRelevance() {
      var sort = currentSort();
      return !sort || sort === 'relevance';
    }

    function currentPageNumber() {
      return parseInt(new URL(window.location.href).searchParams.get('page'), 10) || 1;
    }

    // Orden de la lista: la primera página tal como la da Shopify (lo que el cliente ya ve) y,
    // a partir de ahí, primero lo que lleva lo buscado en el título. Con otro orden elegido
    // (precio, más vendidos…) se respeta tal cual.
    function ordered() {
      var items = F.data.items;
      if (!isRelevance()) return items;
      var keep = currentPageNumber() === 1 ? F.serverCount : 0;
      return items.slice().sort(function (a, b) {
        var ra = a.idx < keep ? -1 : (a.match ? 0 : 1);
        var rb = b.idx < keep ? -1 : (b.match ? 0 : 1);
        return ra - rb || a.idx - b.idx;
      });
    }

    function listMode() {
      return activeCount() > 0 || F.expanded;
    }

    function loadMoreHtml(shown, total) {
      return (
        '<p class="tms-loadmore__count">' + esc(tr('showing', { count: String(shown), total: String(total) })) + '</p>' +
        '<button type="button" class="button button--secondary tms-loadmore__btn" data-tms-fmore-results>' + esc(tr('load_more')) + '</button>'
      );
    }

    function setLoadMore(list, html) {
      var more = page.querySelector('.tms-loadmore');
      if (!html) {
        if (more) more.remove();
        return;
      }
      if (!more) list.insertAdjacentHTML('afterend', '<div class="tms-loadmore">' + html + '</div>');
      else more.innerHTML = html;
    }

    // Sin filtros, en la 1.ª página y por relevancia: «Ver más productos» en lugar de la
    // paginación, para seguir con la lista ordenada por el buscador.
    function offerMore() {
      var list = productList();
      if (!list || !F.data || !isRelevance() || currentPageNumber() !== 1 || F.data.items.length <= F.serverCount) return;
      togglePagination(false);
      setLoadMore(list, loadMoreHtml(F.serverCount, F.data.count));
    }

    function update(opts) {
      opts = opts || {};
      var c = counts();
      renderBar(c);
      if (!drawer.hidden) renderDrawer(c);
      stateToUrl();
      applyGrid(true);
      if (opts.scroll) scrollToGrid();
    }

    function scrollToGrid() {
      var top = card.getBoundingClientRect().top + window.scrollY - 90;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth' });
    }

    // ---- eventos -------------------------------------------------------------------

    bar.addEventListener('click', function (e) {
      var open = e.target.closest('[data-tms-fopen]');
      if (open) {
        openDrawer(open.getAttribute('data-tms-fopen'));
        return;
      }
      var toggle = e.target.closest('[data-tms-ftoggle]');
      if (toggle) {
        F.avail = !F.avail;
        update();
        return;
      }
      var remove = e.target.closest('[data-tms-fremove]');
      if (remove) {
        var k = remove.getAttribute('data-tms-fremove');
        var v = remove.getAttribute('data-v');
        if (k === 'price') delete F.price[v];
        else if (k === 'rating') F.rating = false;
        else if (F.sel[k]) delete F.sel[k][v];
        update();
        return;
      }
      if (e.target.closest('[data-tms-fclear]')) clearAll();
    });

    function clearAll() {
      F.expanded = false;
      F.sel = {};
      F.price = {};
      F.avail = false;
      F.rating = false;
      update({ scroll: true });
    }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-tms-fclose]')) {
        closeDrawer();
        return;
      }
      if (e.target.closest('[data-tms-fclear]')) {
        clearAll();
        return;
      }
      var more = e.target.closest('[data-tms-fmore]');
      if (more) {
        more.closest('.tms-fgroup__body').classList.add('is-expanded');
        more.remove();
      }
    });

    drawer.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('input[type="checkbox"]')) return;
      var kind = input.getAttribute('data-kind');
      var key = input.getAttribute('data-key');
      var v = input.getAttribute('data-v');
      if (kind === 'g') {
        if (!F.sel[key]) F.sel[key] = {};
        if (input.checked) F.sel[key][v] = true;
        else delete F.sel[key][v];
      } else if (kind === 'p') {
        if (input.checked) F.price[v] = true;
        else delete F.price[v];
      } else if (kind === 'a') {
        F.avail = input.checked;
      } else if (kind === 'r') {
        F.rating = input.checked;
      }
      drawerChanged = true;
      update();
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    page.addEventListener('click', function (e) {
      if (e.target.closest('[data-tms-fmore-results]')) {
        if (!listMode()) {
          F.expanded = true;
          F.shown = F.serverCount + 24;
        } else {
          F.shown += 24;
        }
        applyGrid(false);
        return;
      }
      if (e.target.closest('.tms-fempty [data-tms-fclear]')) clearAll();
    });

    // El tema recarga la lista al ordenar, cambiar de página o de nº de productos:
    // se vuelven a aplicar los filtros (y si cambió el orden, se piden los datos en ese orden).
    document.addEventListener('theme:loading:end', function () {
      // Este evento también lo lanzan el mini-carrito, la compra rápida y cart:refresh al
      // volver atrás. Solo es una recarga de la lista si el tema sustituyó la zona de productos.
      var fresh = productList();
      if (!fresh || fresh === knownList) return;
      knownList = fresh;
      F.server = null;
      F.serverList = null;
      F.expanded = false;
      countEls.forEach(function (el) { el.removeAttribute('data-tms-orig'); });
      var list = productList();
      if (list) F.serverCount = list.children.length;
      if (!F.data) return;
      if (F.data.sort !== currentSort()) {
        loadData().then(function () { update(); }).catch(function () { /* se queda sin filtros */ });
      } else {
        stateToUrl();
        applyGrid(true);
      }
    });

    // ---- arranque ------------------------------------------------------------------

    var firstList = productList();
    var knownList = firstList;
    if (firstList) F.serverCount = firstList.children.length;

    var start = function () {
      loadData().then(function () {
        stateFromUrl();
        // Se descartan valores de la URL que ya no existen en estos resultados.
        Object.keys(F.sel).forEach(function (k) {
          var g = F.groups.filter(function (x) { return x.key === k; })[0];
          if (!g) { delete F.sel[k]; return; }
          Object.keys(F.sel[k]).forEach(function (v) {
            if (!g.values.some(function (x) { return x.v === v; })) delete F.sel[k][v];
          });
        });
        var c = counts();
        if (F.groups.length || F.data.items.length >= 8) renderBar(c);
        applyGrid(true);
      }).catch(function (err) {
        console.error('[buscador] filtros', err);
      });
    };

    if ('requestIdleCallback' in window && !new URL(window.location.href).searchParams.get('tf')) {
      window.requestIdleCallback(start, { timeout: 1500 });
    } else {
      start();
    }
  }

  function initPage() {
    initResultsPage();
    var page = document.querySelector('[data-tms-results-page]');
    if (!page) return;
    var q = cleanTerm(page.getAttribute('data-q'));
    var count = parseInt(page.getAttribute('data-count'), 10) || 0;
    if (q && count > 0) initFacets(page, q, count);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage);
  else initPage();
})();
